export default "__VITE_ASSET__Hrl1vlcN__"